export const Images = {
  SocialProfileLabelIcon: {
    CompanyAdmin: require('src/assets/Social/Badge/CompanyAdmin@3x.png'),
    CompanyModerator: require('src/assets/Social/Badge/CompanyModerator@3x.png'),
    CommunityModerator: require('src/assets/Social/Badge/CommunityModerator@3x.png'),
    TestAccount: require('src/assets/Social/Badge/TestAccount@3x.png'),
  },
};
